import { Photo } from "api/types/photo";

import { SurveyFormContainer } from "./SurveyFormContainer";
import { PhotoPreviewUpload } from "./PhotoPreviewUpload";

import { PhotoType } from "api/types/photoType";
import { getMatchingPhoto } from "./helpers/getMatchingPhoto";

export interface PhotosType {
  photoTypes: PhotoType[];
  photos: Photo[];
  onChange: (photos: Photo[]) => void;
  onDelete: (photo: Photo) => void;
}
export function Photos({ photoTypes, photos, onChange, onDelete }: PhotosType) {
  return (
    <SurveyFormContainer className="p-2">
      <div className="row">
        {photoTypes.map((photoType, index) => {
          const borderEnd = index % 2 === 0 ? "border-end" : "";
          const isLastItem = index === photoTypes.length - 1;
          const borderBottom =
            isLastItem && photoTypes.length % 2 > 0 ? "" : "border-bottom";
          const matchingPhoto = getMatchingPhoto(photos, photoType);
          function handlePhotoChange(newPhoto: Photo) {
            const tmpPhotos = [...photos];
            if (matchingPhoto) {
              tmpPhotos[matchingPhoto.index] = { ...newPhoto };
            } else {
              tmpPhotos.push({ ...newPhoto });
            }
            onChange(tmpPhotos);
          }

          return (
            <div
              key={`${photoType.id}-${index}`}
              className={`col-md-6 border-1  ${borderEnd} ${borderBottom} border-light py-2`}
            >
              <div className="">{photoType.text}</div>
              <div className="pb-2 fs-7 text-muted">{photoType.subText}</div>
              <PhotoPreviewUpload
                photo={matchingPhoto?.photo}
                photoType={photoType}
                onChange={handlePhotoChange}
                onDelete={onDelete}
              />
            </div>
          );
        })}
      </div>
    </SurveyFormContainer>
  );
}
